import React, { useState } from 'react';
import '../styles/siteHeader.css';

/* Statik, salt görsel simgeler — HappHealth tasarım sisteminden birebir alınan path'ler. */
const paths: Record<string, string> = {
    pin: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z',
    chevronDown: 'M6 9l6 6 6-6',
    arrowRight: 'M5 12h14M13 6l6 6-6 6',
    menu: 'M4 6h16M4 12h16M4 18h16',
    x: 'M6 6l12 12M18 6 6 18',
};

const Icon: React.FC<{ name: keyof typeof paths }> = ({ name }) => (
    <svg viewBox="0 0 24 24" width="100%" height="100%" fill={name === 'pin' ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={name === 'pin' ? 0 : 2} strokeLinecap="round" strokeLinejoin="round">
        <path d={paths[name]} />
    </svg>
);

const HeartIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M19.5 12.6 12 20l-7.5-7.4a5 5 0 0 1 7.1-7.1l.4.4.4-.4a5 5 0 0 1 7.1 7.1Z" />
    </svg>
);

const CartIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 4h2l2.4 12.4A2 2 0 0 0 9.4 18h8.5a2 2 0 0 0 2-1.6L21 8H6M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    </svg>
);

const GlobeIcon: React.FC = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <circle cx={12} cy={12} r={9} />
        <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
    </svg>
);

interface NavLink { label: string; href: string }
interface NavColumn { title: string; links: NavLink[] }
interface NavItem { key: string; label: string; width: 'wide' | 'mid' | 'narrow'; columns: NavColumn[]; allLabel?: string; allHref?: string }

/* www.happ.health'in kendi canlı sayfalarından alınan gerçek URL'ler. */
const SITE = 'https://www.happ.health';

const NAV: NavItem[] = [
    {
        key: 'checkup', label: 'Check-Up', width: 'mid', allLabel: 'Tüm Check-Up paketleri', allHref: `${SITE}/tr/check-up-listesi/all`,
        columns: [
            {
                title: 'Paketler', links: [
                    { label: 'Tüm Paketler', href: `${SITE}/tr/check-up-listesi/all` },
                    { label: 'Kadın Check-Up', href: `${SITE}/tr/check-up-listesi/kadin` },
                    { label: 'Erkek Check-Up', href: `${SITE}/tr/check-up-listesi/erkek` },
                    { label: 'Çocuk Check-Up', href: `${SITE}/tr/check-up-listesi/cocuk` },
                ],
            },
            {
                title: 'Hastane bazlı', links: [
                    { label: 'Medical Park', href: `${SITE}/tr/check-up-listesi/medicalpark` },
                    { label: 'Liv Hospital', href: `${SITE}/tr/check-up-listesi/liv-hospital` },
                    { label: 'İSÜ Hastanesi', href: `${SITE}/tr/check-up-listesi/istinye-universite-hastanesi` },
                ],
            },
        ],
    },
    {
        key: 'doktor', label: 'Doktor', width: 'wide', allLabel: 'Tüm branşlar', allHref: `${SITE}/doktor`,
        columns: [
            {
                title: 'Branşlar', links: [
                    { label: 'Psikiyatri', href: `${SITE}/tr/online-psikiyatri` },
                    { label: 'Dermatoloji', href: `${SITE}/tr/online-dermatoloji` },
                    { label: 'Çocuk Sağlığı', href: `${SITE}/tr/online-cocuk-sagligi-ve-hastaliklari` },
                    { label: 'Kadın Hastalıkları', href: `${SITE}/tr/online-kadin-hastaliklari-ve-dogum` },
                ],
            },
            {
                title: ' ', links: [
                    { label: 'Kardiyoloji', href: `${SITE}/tr/online-kardiyoloji` },
                    { label: 'Nöroloji', href: `${SITE}/tr/online-noroloji` },
                    { label: 'Üroloji', href: `${SITE}/tr/online-uroloji` },
                    { label: 'KBB', href: `${SITE}/tr/online-kulak-burun-bogaz` },
                ],
            },
            {
                title: 'Danışmanlık', links: [
                    { label: 'Psikolog', href: `${SITE}/brans/psikoloji` },
                    { label: 'Diyetisyen', href: `${SITE}/brans/beslenme-ve-diyetetik` },
                    { label: 'Anında Doktor', href: `${SITE}/aninda-doktor` },
                ],
            },
        ],
    },
    {
        key: 'evde', label: 'Evde Sağlık', width: 'mid', allLabel: 'Tüm evde sağlık hizmetleri', allHref: `${SITE}/tr/evde-saglik`,
        columns: [
            {
                title: 'Hizmetler', links: [
                    { label: 'Evde Uzman Doktor', href: `${SITE}/tr/evde-saglik/evde-uzman-doktor` },
                    { label: 'Evde Serum', href: `${SITE}/tr/evde-saglik/evde-serum-hizmetleri` },
                    { label: 'Evde Hemşirelik', href: `${SITE}/tr/evde-saglik/evde-hemsire` },
                    { label: 'Evde Check-Up', href: `${SITE}/tr/evde-saglik/check-up-paketleri` },
                ],
            },
            {
                title: ' ', links: [
                    { label: 'Evde Laboratuvar', href: `${SITE}/tr/evde-saglik/evde-laboratuvar-hizmeti` },
                    { label: 'Evde Tetkik ve Görüntüleme', href: `${SITE}/tr/evde-saglik/evde-radyoloji-ve-goruntuleme` },
                    { label: 'Evde Yoğun Bakım', href: `${SITE}/tr/evde-saglik/evde-yogun-bakim` },
                ],
            },
        ],
    },
    {
        key: 'eczane', label: 'Nöbetçi Eczane', width: 'narrow', allLabel: 'Tüm nöbetçi eczaneler', allHref: `${SITE}/nobetci-eczane`,
        columns: [
            {
                title: 'Şehirler', links: [
                    { label: 'İstanbul', href: `${SITE}/nobetci-eczane/istanbul` },
                    { label: 'Ankara', href: `${SITE}/nobetci-eczane/ankara` },
                    { label: 'İzmir', href: `${SITE}/nobetci-eczane/izmir` },
                    { label: 'Kadıköy', href: `${SITE}/nobetci-eczane/istanbul/kadikoy` },
                ],
            },
        ],
    },
    {
        key: 'dunya', label: 'Happ Dünyası', width: 'mid',
        columns: [
            {
                title: 'Keşfet', links: [
                    { label: 'Kampanyalar', href: `${SITE}/tr/kampanyalar` },
                    { label: 'HappAi', href: `${SITE}/ai/chat` },
                    { label: 'Hangi Diyet', href: `${SITE}/ai/hangi-diyet` },
                ],
            },
            {
                title: ' ', links: [
                    { label: 'Blog', href: `${SITE}/blog` },
                    { label: 'Premium Üyelik', href: `${SITE}/premium` },
                    { label: 'Kurumsal İş Birlikleri', href: `${SITE}/tr/kurumsal-is-birlikleri` },
                ],
            },
        ],
    },
];

const HOME_HREF = `${SITE}/tr`;
const PHARM_HREF = `${SITE}/nobetci-eczane/istanbul`;
const FAVORITES_HREF = `${SITE}/tr/favoriler`;
const CART_HREF = `${SITE}/sepet`;
/* "Giriş Yap" ayrı bir sayfa değil, ana sitede JS ile açılan bir modal —
   en yakın gerçek karşılığı ana sayfaya yönlendirmek (kullanıcı oradan giriş yapabilir). */
const LOGIN_HREF = HOME_HREF;

const LANGS = [
    { code: 'TR', name: 'Türkçe' },
    { code: 'EN', name: 'English' },
];

/* Widget bir iframe içinde açılmışsa gerçek gezinme üst pencerede gerçekleşsin —
   chat.tsx'teki kapat butonuyla aynı yaklaşım. */
const navigate = (url: string) => {
    if (typeof window === 'undefined') return;
    if (window.top) {
        window.top.location.href = url;
    } else {
        window.location.href = url;
    }
};

const navClick = (url: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(url);
};

/* Ana Happ Health site header'ının gerçek happ.health linklerine bağlı görsel kopyası.
   HappAI sohbet widget'ı bu header'ın altına, gerçek sitedeki gibi yerleşir. */
const SiteHeader: React.FC = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [langOpen, setLangOpen] = useState(false);
    const [lang, setLang] = useState('TR');

    return (
        <>
            <header className="hdr">
                <div className="wrap">
                    <a className="brand" href={HOME_HREF} onClick={navClick(HOME_HREF)}>
                        <img className="logo-img" src="/images/happ-navy-tight.png" alt="Happ" />
                    </a>
                    <a className="pharm" href={PHARM_HREF} onClick={navClick(PHARM_HREF)}>
                        <span className="ic"><Icon name="pin" /></span>
                        <div className="pcol">
                            <span className="pover">EN YAKIN NÖBETÇİ ECZANE</span>
                            <span className="ploc">Beşiktaş, İstanbul</span>
                        </div>
                        <span className="badge-open">AÇIK</span>
                    </a>

                    <nav className="hnav">
                        {NAV.map((item) => (
                            <div className="navitem" key={item.key}>
                                <button className="navtrig" type="button">
                                    {item.label} <span className="caret"><Icon name="chevronDown" /></span>
                                </button>
                                <div className={`mega ${item.width}`}>
                                    <div className={`mcols c${item.columns.length}`}>
                                        {item.columns.map((col, i) => (
                                            <div key={i}>
                                                <div className="mtitle">{col.title}</div>
                                                {col.links.map((l) => (
                                                    <a className="mlink" href={l.href} key={l.label} onClick={navClick(l.href)}>
                                                        <span className="di"></span>{l.label}
                                                    </a>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    {item.allLabel && (
                                        <div className="mfoot">
                                            <a className="mall" href={item.allHref} onClick={navClick(item.allHref as string)}>
                                                {item.allLabel} <span className="ic"><Icon name="arrowRight" /></span>
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </nav>

                    <a className="hdr-ico" href={FAVORITES_HREF} onClick={navClick(FAVORITES_HREF)} aria-label="Favoriler"><HeartIcon /></a>
                    <a className="hdr-ico" href={CART_HREF} onClick={navClick(CART_HREF)} aria-label="Sepet"><CartIcon /></a>

                    <div className={`happ-lang notranslate${langOpen ? ' open' : ''}`}>
                        <button type="button" className="happ-lang-btn" aria-haspopup="true" aria-expanded={langOpen} aria-label="Dil seçimi" onClick={() => setLangOpen((v) => !v)}>
                            <span className="hl-globe"><GlobeIcon /></span>
                            <span className="hl-cur">{lang}</span>
                            <span className="hl-caret"><Icon name="chevronDown" /></span>
                        </button>
                        {langOpen && (
                            <div className="happ-lang-sheet">
                                {LANGS.map((l) => (
                                    <button
                                        key={l.code}
                                        type="button"
                                        className={`happ-lang-opt${l.code === lang ? ' on' : ''}`}
                                        onClick={() => {
                                            setLang(l.code);
                                            setLangOpen(false);
                                            navigate(l.code === 'EN' ? `${SITE}/en` : `${SITE}/tr`);
                                        }}
                                    >
                                        <span className="hl-code">{l.code}</span>{l.name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <a className="btn-login" href={LOGIN_HREF} onClick={navClick(LOGIN_HREF)}>Giriş Yap</a>

                    <button className="hdr-burger" aria-label="Menü" type="button" onClick={() => setMobileOpen(true)}>
                        <Icon name="menu" />
                    </button>
                </div>
            </header>

            <div className={`mnav-scrim${mobileOpen ? ' open' : ''}`} onClick={() => setMobileOpen(false)} />
            <aside className={`mnav${mobileOpen ? ' open' : ''}`} role="dialog" aria-label="Menü">
                <div className="mnav-head">
                    <img className="logo-img" src="/images/happ-navy-tight.png" alt="Happ" />
                    <button className="mnav-x" aria-label="Kapat" type="button" onClick={() => setMobileOpen(false)}>
                        <Icon name="x" />
                    </button>
                </div>
                <div className="mnav-body">
                    <a className="mnav-home" href={HOME_HREF} onClick={navClick(HOME_HREF)}>Ana Sayfa</a>
                    <a className="mnav-pharm" href={PHARM_HREF} onClick={navClick(PHARM_HREF)}>
                        <span className="ic"><Icon name="pin" /></span>
                        <span className="pcol">
                            <span className="pover">EN YAKIN NÖBETÇİ ECZANE</span>
                            <span className="ploc">Beşiktaş, İstanbul</span>
                        </span>
                        <span className="badge-open">AÇIK</span>
                    </a>
                    {NAV.map((item) => (
                        <details className="mnav-grp" key={item.key}>
                            <summary>{item.label}<span className="gchev"><Icon name="chevronDown" /></span></summary>
                            <div className="mnav-sub">
                                {item.columns.flatMap((col) => col.links).map((l) => (
                                    <a href={l.href} key={l.label} onClick={navClick(l.href)}>
                                        <span className="di"></span>{l.label}
                                    </a>
                                ))}
                            </div>
                        </details>
                    ))}
                </div>
                <div className="mnav-foot">
                    <a className="mnav-cta" href={LOGIN_HREF} onClick={navClick(LOGIN_HREF)}>Giriş Yap</a>
                </div>
            </aside>
        </>
    );
};

export default SiteHeader;
